<form>
    <app-form-section [formGroup]="rentalForm">
        <app-form-row-header [title]="'FEATURES.AGREEMENTS.GROUP_TITLE_RENTAL' | translate" icon="directions_car" />
        <div class="form">
            <app-form-row>
                <app-form-group>
                    <label for="employeeNo">{{ 'FEATURES.AGREEMENTS.EMPLOYEE_NO' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="employeeNo"
                        formControlName="employeeNo"
                        type="text"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="employeeName">{{ 'FEATURES.AGREEMENTS.EMPLOYEE_NAME' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="employeeName"
                        formControlName="employeeName"
                        type="text"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="grossSalaryDeduction">{{
                        'FEATURES.AGREEMENTS.GROSS_SALARY_DEDUCTION' | translate
                    }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="grossSalaryDeduction"
                        formControlName="grossSalaryDeduction"
                        type="number"
                        min="0"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="benefitValue">{{ 'FEATURES.AGREEMENTS.BENEFIT_VALUE' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="benefitValue"
                        formControlName="benefitValue"
                        type="number"
                        min="0"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <app-checkbox
                        [text]="'FEATURES.AGREEMENTS.ADDITIONAL_INSURANCE' | translate"
                        formControlName="additionalInsurance"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="registrationNo">{{ 'FEATURES.AGREEMENTS.REGISTRATION_NO' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="registrationNo"
                        formControlName="registrationNo"
                        type="text"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="carBrand">{{ 'FEATURES.AGREEMENTS.CAR_BRAND' | translate }}</label>
                    <app-listtype-select
                        formControlName="carBrand"
                        listType="CAR_BRAND"
                        [showPotentialValidationMessages]="true"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="carModel">{{ 'FEATURES.AGREEMENTS.CAR_MODEL' | translate }}</label>
                    <app-listtype-select
                        formControlName="carModel"
                        listType="CAR_MODEL"
                        [showPotentialValidationMessages]="true"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="modelYear">{{ 'FEATURES.AGREEMENTS.CAR_YEAR' | translate }}</label>
                    <app-dropdown [items]="modelYears" formControlName="modelYear" />
                </app-form-group>
                <app-form-group>
                    <label for="mileageAnnual">{{ 'FEATURES.AGREEMENTS.CAR_MILEAGE' | translate }}</label>
                    <app-dropdown [items]="mileageAnnualOptions" formControlName="mileageAnnual" />
                </app-form-group>
            </app-form-row>
        </div>
    </app-form-section>
</form>
